/** ITS number with standard narration prefix (avoids duplicating "ITS #"). */
export function formatNarrationIts(itsNo: unknown): string {
  const n = String(itsNo ?? "").trim();
  if (!n) return "";
  if (/^ITS\s*#/i.test(n)) return n;
  return `ITS #${n}`;
}

/** Whole rupee amount with ₹ prefix for narrations. */
export function formatNarrationRupee(amount: unknown): string {
  if (amount == null || amount === "") return "";
  const n = Number(amount);
  if (!Number.isFinite(n)) return "";
  return `₹${Math.round(n)}`;
}

/** Transaction ID / payment reference for narrations (e.g. "Txn #123456"). */
export function formatNarrationTransactionId(txnId: unknown): string {
  const t = String(txnId ?? "").trim();
  if (!t) return "";
  if (/^(txn|ref|utr|#)/i.test(t)) return t;
  return `Txn #${t}`;
}
